import styled from 'styled-components';

import { mediaQueryLaptopMin } from 'styles';

export const Wrapper = styled.aside`
  width: 100%;

  @media all and ${mediaQueryLaptopMin} {
    width: 300px;
  }
`;

// Component kept for semantic and structural purposes, no styles needed
export const InfoContent = styled.div``;

export default Wrapper;
